var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    attrs: {
      "viewBox": "0 0 200 200",
      "width": "200",
      "height": "200",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "transform": "translate(-0.000000,-0.000000) scale(0.377358) translate(-0.000000,-0.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "svg-1",
      "transform": "matrix(0.2512649893760681, 0, 0, 0.2512649893760681, -96.57250976562494, 4.910460948944092)"
    }
  }, [_c('g', {
    attrs: {
      "id": "svg-2"
    }
  }, [_c('g', {
    attrs: {
      "id": "SVGRepo_bgCarrier",
      "stroke-width": "0",
      "transform": "matrix(0.248047, 0, 0, 0.248047, 881.591553, 347.236969)"
    }
  }), _c('g', {
    attrs: {
      "id": "SVGRepo_tracerCarrier",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "transform": "matrix(0.248047, 0, 0, 0.248047, 881.591553, 347.236969)"
    }
  }), _c('g', {
    attrs: {
      "id": "SVGRepo_iconCarrier",
      "transform": "matrix(0.248047, 0, 0, 0.248047, 881.591553, 347.236969)"
    }
  }, [_c('g', {
    attrs: {
      "id": "svg-3",
      "transform": "matrix(3.979864, 0, 0, 3.979864, 1196.199463, 2118.139648)"
    }
  }, [_c('g', {
    attrs: {
      "id": "group-1",
      "stroke-width": "0",
      "transform": "matrix(0.999997, 0, 0, 0.999997, -803.484619, -901.903625)"
    }
  }), _c('g', {
    attrs: {
      "id": "group-2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "transform": "matrix(0.999997, 0, 0, 0.999997, -803.484619, -901.903625)"
    }
  }), _c('g', {
    attrs: {
      "id": "group-3",
      "transform": "matrix(0.999999, 0, 0, 0.999999, -803.484619, -901.903625)"
    }
  }, [_c('g', {
    attrs: {
      "id": "group-4",
      "stroke-width": "0",
      "transform": "matrix(3.985507, 0, 0, 3.985507, 1.874695, 0.230631)"
    }
  }), _c('g', {
    attrs: {
      "id": "group-5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "transform": "matrix(3.985507, 0, 0, 3.985507, 1.874695, 0.230631)"
    }
  }), _c('g', {
    attrs: {
      "id": "group-6",
      "transform": "matrix(3.985507, 0, 0, 3.985507, 1.874695, 0.230631)"
    }
  }, [_c('circle', {
    staticStyle: {
      "fill": "#f1543f"
    },
    attrs: {
      "cx": "256",
      "cy": "256",
      "r": "256"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#d83e20"
    },
    attrs: {
      "d": "M 501.663 322.883 L 333.379 144.345 L 266.369 189.35 L 105.264 187.708 L 226.301 337.895 L 168.854 378.755 C 168.854 378.755 283.734 506.358 283.879 506.353 C 408.69 501.751 487.635 391.854 501.663 322.883 Z"
    }
  }), _c('g', {
    attrs: {
      "id": "group-13",
      "stroke-width": "0",
      "transform": "matrix(0.249447, 0, 0, 0.249447, 1.68398, 411.749695)"
    }
  }), _c('g', {
    attrs: {
      "id": "group-14",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "transform": "matrix(0.249447, 0, 0, 0.249447, 1.68398, 411.749695)"
    }
  }), _c('g', {
    attrs: {
      "id": "svg-4",
      "transform": "matrix(1, 0, 0, 1, -303.33197, -307.584198)"
    }
  }, [_c('g', {
    attrs: {
      "id": "group-7",
      "stroke-width": "0",
      "transform": "matrix(0.250909, 0, 0, 0.250909, 139.644882, 182.057816)"
    }
  }), _c('g', {
    attrs: {
      "id": "group-8",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "transform": "matrix(0.250909, 0, 0, 0.250909, 139.644882, 182.057816)"
    }
  }), _c('g', {
    attrs: {
      "id": "group-9",
      "transform": "matrix(0.250909, 0, 0, 0.250909, 139.644882, 182.057816)"
    }
  }, [_c('path', {
    staticStyle: {
      "fill": "rgb(208, 209, 211)"
    },
    attrs: {
      "d": "M 1452.97 1250.99 L 1452.97 1160.76 C 1452.97 1096.51 1693.79 1044.41 1758.05 1044.41 L 1178.87 1044.41 C 1114.61 1044.41 1062.51 1096.51 1062.51 1160.76 L 1062.51 1250.99 L 1452.97 1250.99 Z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "rgb(255, 255, 255)"
    },
    attrs: {
      "d": "M 1326.57 2009.63 L 1326.57 1160.76 C 1326.57 1096.51 1274.47 1044.41 1210.18 1044.41 L 1915.26 1044.41 C 1979.55 1044.41 2031.65 1096.51 2031.65 1160.76 L 2031.65 2009.63 L 1326.57 2009.63 Z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "rgb(208, 209, 211)"
    },
    attrs: {
      "d": "M 2031.65 1160.76 C 2031.65 1096.51 1979.55 1044.41 1915.26 1044.41 L 1690.01 1044.41 L 1690.01 2009.63 L 2031.65 2009.63 L 2031.65 1160.76 Z"
    }
  }), _c('g', {
    attrs: {
      "transform": "matrix(3.407174, 0, 0, 3.407174, 674.84198, 656.744812)"
    }
  }, [_c('path', {
    staticStyle: {
      "fill": "#808183"
    },
    attrs: {
      "d": "M369.778,205.145H227.556c-3.332,0-6.034-2.701-6.034-6.034c0-3.332,2.701-6.034,6.034-6.034 h142.222c3.332,0,6.034,2.701,6.034,6.034C375.811,202.443,373.11,205.145,369.778,205.145z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#808183"
    },
    attrs: {
      "d": "M369.778,233.589H227.556c-3.332,0-6.034-2.701-6.034-6.034c0-3.332,2.701-6.034,6.034-6.034 h142.222c3.332,0,6.034,2.701,6.034,6.034C375.811,230.888,373.11,233.589,369.778,233.589z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#808183"
    },
    attrs: {
      "d": "M369.778,262.034H227.556c-3.332,0-6.034-2.701-6.034-6.034s2.701-6.034,6.034-6.034h142.222 c3.332,0,6.034,2.701,6.034,6.034S373.11,262.034,369.778,262.034z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#808183"
    },
    attrs: {
      "d": "M369.778,290.478H227.556c-3.332,0-6.034-2.701-6.034-6.034s2.701-6.034,6.034-6.034h142.222 c3.332,0,6.034,2.701,6.034,6.034S373.11,290.478,369.778,290.478z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#808183"
    },
    attrs: {
      "d": "M369.778,318.923H227.556c-3.332,0-6.034-2.701-6.034-6.034s2.701-6.034,6.034-6.034h142.222 c3.332,0,6.034,2.701,6.034,6.034S373.11,318.923,369.778,318.923z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#808183"
    },
    attrs: {
      "d": "M369.778,347.367H227.556c-3.332,0-6.034-2.701-6.034-6.034s2.701-6.034,6.034-6.034h142.222 c3.332,0,6.034,2.701,6.034,6.034S373.11,347.367,369.778,347.367z"
    }
  })]), _c('rect', {
    staticStyle: {
      "fill": "rgb(201, 47, 0)"
    },
    attrs: {
      "x": "1547.08",
      "y": "1141.31",
      "width": "290.744",
      "height": "96.914"
    }
  }), _c('g', {
    attrs: {
      "transform": "matrix(3.407174, 0, 0, 3.407174, 674.84198, 656.744812)"
    }
  }, [_c('path', {
    staticStyle: {
      "fill": "#59595b"
    },
    attrs: {
      "d": "M369.778,193.077H297.95v12.067h71.828c3.332,0,6.034-2.701,6.034-6.034 C375.811,195.779,373.11,193.077,369.778,193.077z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#59595b"
    },
    attrs: {
      "d": "M369.778,221.522H297.95v12.067h71.828c3.332,0,6.034-2.701,6.034-6.034 C375.811,224.223,373.11,221.522,369.778,221.522z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#59595b"
    },
    attrs: {
      "d": "M369.778,249.966H297.95v12.067h71.828c3.332,0,6.034-2.701,6.034-6.034 S373.11,249.966,369.778,249.966z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#59595b"
    },
    attrs: {
      "d": "M369.778,278.411H297.95v12.067h71.828c3.332,0,6.034-2.701,6.034-6.034 S373.11,278.411,369.778,278.411z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#59595b"
    },
    attrs: {
      "d": "M369.778,306.855H297.95v12.067h71.828c3.332,0,6.034-2.701,6.034-6.034 S373.11,306.855,369.778,306.855z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#59595b"
    },
    attrs: {
      "d": "M369.778,335.3H297.95v12.067h71.828c3.332,0,6.034-2.701,6.034-6.034S373.11,335.3,369.778,335.3z"
    }
  })]), _c('rect', {
    staticStyle: {
      "fill": "rgb(147, 0, 0)"
    },
    attrs: {
      "x": "1689.97",
      "y": "1141.31",
      "width": "147.841",
      "height": "96.914"
    }
  })])])])])])])])])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }